import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const getPrefrencesClient = async (requestBody) => {
    const { post: postClient } = BaseClient();
    try {
        return await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.getPreferences(), requestBody, {}, true);
    } catch (error) {
        return { error: 'Some error occured. Please try again' };

    }
};

export default getPrefrencesClient;